import styles from './Footer.module.css';
import Container from '../../common/Container/Container';

const CURRENT_YEAR = new Date().getFullYear();

const NAV_LINKS = [
  { name: 'Solutions', id: 'solutions' },
  { name: 'Portfolio', id: 'portfolio' },
  { name: 'Process',   id: 'process'   },
  { name: 'About',     id: 'about'     },
];

const SERVICES = [
  'Custom Web Applications',
  'Business Process Automation',
  'Mobile App Development',
  'Website & UX/UI Design',
];

const scrollTo = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <Container>
        <div className={styles.footerContent}>

          {/* Brand */}
          <div className={styles.footerSection}>
            <div className={styles.logo}>
              <img
                src="/images/logo/WIDE%20BLUE%20LIGHT.png"
                alt="Kilonova Technologies"
                className={styles.logoImage}
              />
            </div>
            <p className={styles.tagline}>
              Transforming Business Challenges Into Digital Solutions
            </p>
            <p className={styles.copyright}>
              © {CURRENT_YEAR} Kilonova Technologies. All rights reserved.
            </p>
          </div>

          {/* Services */}
          <div className={styles.footerSection}>
            <h4 className={styles.sectionTitle}>Services</h4>
            <ul className={styles.linkList}>
              {SERVICES.map(name => (
                <li key={name}>
                  <button className={styles.footerLink} onClick={() => scrollTo('solutions')}>
                    {name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div className={styles.footerSection}>
            <h4 className={styles.sectionTitle}>Company</h4>
            <ul className={styles.linkList}>
              {NAV_LINKS.map(link => (
                <li key={link.id}>
                  <button className={styles.footerLink} onClick={() => scrollTo(link.id)}>
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className={styles.footerSection}>
            <h4 className={styles.sectionTitle}>Get In Touch</h4>
            <ul className={styles.contactList}>
              <li>
                <a href="mailto:hello@kilonovatech.co.za" className={styles.contactLink}>
                  📧 hello@kilonovatech.co.za
                </a>
              </li>
              <li>📍 Johannesburg, South Africa</li>
            </ul>
            <p className={styles.easterEggHint}>
              💡 Developers: Through which port can you travel but never leave?
            </p>
          </div>

        </div>

        <div className={styles.footerBottom}>
          <p className={styles.builtWith}>
            Built with ❤️ using React and modern web technologies
          </p>
          <span
            className={styles.easterEgg}
            onClick={() => document.dispatchEvent(new CustomEvent('easterEggFound'))}
          >
            :3000
          </span>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
